import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import {
  CashCollection, CreateCollectionInput,
  recordCollection, listMyCollections, listAllCollections,
} from '../services/cashCollectionsApi';

interface CollectionsState {
  items: CashCollection[];
  saving: boolean;
  loading: boolean;
  error: string | null;
  fetchMine: (from?: string, to?: string) => Promise<void>;
  fetchAll: (filters?: { driverId?: number; from?: string; to?: string }) => Promise<void>;
  record: (input: CreateCollectionInput) => Promise<CashCollection>;
}

const toErr = (e: unknown) => (e instanceof Error ? e.message : 'Something went wrong');

export const useCashCollectionsStore = create<CollectionsState>()(
  devtools(
    (set) => ({
      items: [],
      saving: false,
      loading: false,
      error: null,
      fetchMine: async (from, to) => {
        set({ loading: true, error: null });
        try { set({ items: await listMyCollections(from, to), loading: false }); }
        catch (err) { set({ loading: false, error: toErr(err) }); }
      },
      fetchAll: async (filters) => {
        set({ loading: true, error: null });
        try { set({ items: await listAllCollections(filters), loading: false }); }
        catch (err) { set({ loading: false, error: toErr(err) }); }
      },
      record: async (input) => {
        set({ saving: true, error: null });
        try {
          const created = await recordCollection(input);
          set((s) => ({ items: [created, ...s.items], saving: false }));
          return created;
        } catch (err) {
          set({ saving: false, error: toErr(err) });
          throw err;
        }
      },
    }),
    { name: 'cash-collections-store' }
  )
);
